import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import UItem from '../item';
import { InputTextProps, InputTextState } from './type';
import InputWidget from './inputText';

class InputText extends React.PureComponent<InputTextProps, InputTextState> {
  static propTypes = {
    prefixCls: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    isBlock: PropTypes.bool,
  };

  static defaultProps = {
    prefixCls: 'crm-input-text',
    isBlock: true,
    className: '',
    onChange: () => {},
  };

  onValueChange = (value:any) => {
    const { onChange, ...rest } = this.props;

    if (onChange) {
      onChange({
        ...rest,
        value,
      });
    }
  };

  getDefaultValue = () => {
    const { options, defaultValue } = this.props;
    if (defaultValue) {
      return defaultValue;
    }
    return options.map((item) => {
      const { dataBind, name, defaultValue: childDefaultValue} = item;
      return {
        name: dataBind || name,
        value: childDefaultValue || ''
      };
    });
  };

  render() {
    const {
      onChange,
      defaultValue,
      prefixCls,
      className,
      isBlock,
      ...rest
    } = this.props;
    const cls = classnames({ inline: !isBlock }, className, prefixCls);

    return (
      <UItem
        className={cls}
        {...rest}
        initialValue={this.getDefaultValue() || ''}
      >
        <InputWidget
          onChange={this.onValueChange}
          defaultValue={this.getDefaultValue()}
          {...rest}
        />
      </UItem>
    );
  }
}

export default InputText;
